module.exports = __webpack_public_path__ + "static/media/networking.d1ae78a0.pdf";